// extracted by mini-css-extract-plugin
export default {"countries":"styles_countries__fNaMa","island-restrictions":"styles_island-restrictions__-AqqX","allowed":"styles_allowed__0nRiM","description":"styles_description__JFVdz"};